import styled from 'styled-components'
import media from 'styled-media-query'
import { theme } from 'styled-tools'

import {
  sizes,
  palette,
  zIndex,
  radius,
  fontWeight,
  speed,
} from '../../design/StyleGuide/StyleGuide'

// TODO: This was added to help V1 button on Top Navigation work.
export const ButtonNew = styled.a`
  padding: 10px 20px;
  /* background-color: #02a7e3; */
  background-color: #4caf50;
  color: white !important;
  border-radius: 5px;
  font-size: 14px;
  text-decoration: none;
  font-weight: bold;
  margin-right: 20px;

  &:hover {
    background-color: #02a7e3;
    text-decoration: none;
  }
`

export const SubList = styled.ul`
  display: flex;
  flex-direction: column;
  background: ${palette.background};
  border-radius: ${radius.base};
  color: ${palette.text};
  padding: 0;
  margin: ${sizes.sm} 0 0;
  min-width: ${sizes.xxl};
`

export const ContainerAnchor = styled.article`
  --nav-shadow: 0px 4px 15px -10px rgba(45, 48, 51, 0.43);
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  z-index: ${zIndex._donotUse};
`

export const PortraitContainer = styled.div`
  position: relative;
  width: 100%;
  transition: transform 500ms cubic-bezier(0.78, -0.1, 0, 1.03);
  ${({ isScrollingUp }) =>
    isScrollingUp &&
    `
      transform: translateY(-100%);
  `}
`

export const PortraitView = styled.div`
  width: 100%;
  box-shadow: var(--nav-shadow);

  ${media.greaterThan('large')`
    display: none;
  `}
`

export const LandscapeView = styled.div`
  width: 100%;
  height: 100%;
  background: ${palette.neutral};
  display: none;
  box-shadow: var(--nav-shadow);

  ${media.greaterThan('large')`
    display: block;
  `}
`

export const NavLandscape = styled.div`
  width: 100%;
  max-width: var(--sizes-container);

  ${props =>
    props.maxWidth &&
    `
    max-width: ${props.maxWidth};
  `}

  padding: 0 ${theme('sizes.hBleed')};
  margin-left: auto;
  margin-right: auto;
  display: flex;
  color: ${palette.text};
  align-items: center;
`

export const List = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`

export const LinkWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;

  &:not(:first-child) {
    margin-left: ${sizes.sm};
  }

  &:hover {
    color: ${palette.action};
  }
`

export const ToolTip = styled.div`
  position: absolute;
  top: ${sizes.md};
  left: -${sizes.sm};
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  box-shadow: 0px 7px 8px -4px rgba(0, 0, 0, 0.19);
  z-index: ${zIndex.foreground};
  transform: scaleY(0);
  transition: transform ${speed.fast} cubic-bezier(0.19, -0.04, 0, 1.11);
  transform-origin: left top;

  /* stylelint-disable */
  ${LinkWrapper}:hover & {
    /* stylelint-enable */
    transform: scaleY(1);
  }
`

export const Icon = styled.div`
  display: flex;
  align-items: center;
  margin-top: 2px;
`

export const Link = styled.a`
  /* FIXME: Use var */
  padding: ${sizes.xs} 3px ${sizes.xs} ${sizes.xs};
  font-size: ${sizes.base};
  color: currentColor;
  transition: color ${speed.base} ease;

  &:hover {
    color: ${palette.action};
  }

  /* NOTE: When sublist Link is in landscape */
  /* stylelint-disable */
  ${NavLandscape} ${SubList} > & {
    /* stylelint-enable */
    min-width: 178px;
    padding: ${sizes.sm} ${sizes.xs} ${sizes.sm} calc(${sizes.sm} + ${sizes.sm});
    font-size: 14px;
  }
`

export const LogoSection = styled.a`
  flex: 0 0 80px;
  display: flex;
  align-items: center;
  padding: 13px 0;

  img {
    width: initial;
    height: 37px;
  }
`

export const LandscapeNavSection = styled.div`
  flex: 0 0 auto;
  margin-right: auto;
  margin-left: ${sizes.md};

  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const CTASection = styled.div`
  flex: 0 0 auto;
  margin: 0 0 0 ${theme('sizes.hAtomMargin')};
  display: flex;
  align-items: center;
`

export const CTALink = styled.a`
  &:hover {
    color: ${palette.action};
  }
`

export const Drawer = styled.aside`
  text-align: left;
  position: absolute;
  top: 0;
  left: 0;
  width: 80vw;
  max-width: 240px;
  height: 100vh;
  background: ${palette.background};
  display: flex;
  flex-direction: column;
  transform: translateX(-100%);
  transition: transform ${speed.base} ease;

  ${props =>
    props.isOpen &&
    `
    transform: translateX(0);
  `}
`

export const Header = styled.section`
  flex: 0 0 auto;
  width: 100%;
  padding: 21px 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const IconClose = styled.div`
  width: 100%;

  svg {
    width: 17px;
    height: 17px;
  }
`

export const IconLogo = styled.div`
  width: 100%;
  text-align: right;

  svg {
    width: 40px;
    height: 35px;
  }
`

export const Main = styled.section`
  flex: 1 1 auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`

export const PortraitList = styled.ul`
  margin: 0;
  padding: 0;
  list-style-type: none;
`

export const PortraitListItem = styled.li`
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
`

export const PortraitLink = styled.a`
  padding: 10px 20px;
  font-size: 14px;
  font-weight: ${fontWeight.bold};
  color: ${palette.info};
  text-transform: capitalize;

  &:hover {
    color: ${palette.action};
  }
`

export const PortraitSubLink = styled.a`
  padding: 10px 20px;
  font-size: 14px;
  font-weight: ${fontWeight.base};
  color: ${palette.info};
  text-transform: capitalize;
`

export const Footer = styled.div`
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 10px 0 32px 0;
`

export const BtnGetStarted = styled.a`
  width: 100%;
  padding: 10px 20px;
  color: ${palette.green};
  display: flex;
  align-items: center;
  cursor: pointer;

  svg {
    margin-left: ${sizes.xs};
  }
`

export const PortraitNavSubList = styled.ul`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0;
  /* FIXME: Use var */
  font-size: 14px;
  font-weight: ${fontWeight.base};
  color: ${palette.text};
  transform: scaleY(0);
  /* FIXME: Not working as intended */
  transition: transform ${speed.fast} cubic-bezier(0.19, -0.04, 0, 1.11)
    ${speed.base};
  transform-origin: left top;

  ${props =>
    props.isOpen &&
    `
    transform: scaleY(1);
  `}
`

export const LineItem = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
`

export const DropDownIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 20px;
  cursor: pointer;
  transition: transform ${speed.base} ease;

  ${props =>
    props.isOpen &&
    `
    transform: rotate(180deg)
  `};
`

export const bottomCTA = styled.div`
  align-items: center;
  background-color: ${palette.neutral};
  justify-content: space-between;
`
export const Menu = styled.div`
  width: 100%;
  /* height: 80px; */
  height: 65px;
  display: flex;
  align-items: center;
  background-color: ${palette.neutral};
  justify-content: space-between;
  transition: transform ${speed.fast} ease;

  ${props =>
    props.isOpen &&
    `
    transform: translateY(-100%);
  `}
`

export const BtnBurger = styled.div`
  flex: 0 0 calc(100% / 3);
  display: flex;
  align-items: center;
  padding: 31px 21px 33px ${theme('sizes.hBleed')};
  background-color: transparent;
  border: 0 solid transparent;
  justify-content: flex-start;

  svg {
    /* TO FIX: This SVG is distorting with WIDTH applied */
    /* width: 26px; */
    height: 18px;
  }
`

export const BtnMenuLogin = styled.a`
  flex: 0 0 calc(100% / 3);
  padding: 20px ${theme('sizes.hBleed')} 20px;
  text-align: right;

  &:hover {
    color: ${palette.action};
  }
`

export const MenuLogo = styled.a`
  flex: 0 0 calc(100% / 3);
  text-align: center;
  margin: 0;

  svg {
    width: 40px;
    height: 35px;
  }
`



// WEBPACK FOOTER //
// ./includes/yoco-website-cms-gatsby/src/components/element/Navigation/styled.js